






import Vue from "vue";
import { RodzajKomponentu } from "@megarax/client/src/resources/plm";

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: RodzajKomponentu,
      required: true,
    },
  },
});
